import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1),
  },
  titleText: {
    flex: 1,
    fontWeight: "bold",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
  },
  blackIcon: {
    color: "#000", // Set icon color to black
  },
  backText: {
    marginLeft: theme.spacing(0.5), // Adds space between the icon and the "Back" text
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000",
  },
  noHighlight: {
    backgroundColor: "transparent !important", // Disables hover background color
    boxShadow: "none", // Removes any potential shadow
  },
}));

const CustomDialogTitle = ({ onBackClick, title, rightContent }) => {
  const classes = useStyles();

  return (
    <>
      <DialogTitle disableTypography className={classes.root}>
        <div className={classes.backButton}>
          <IconButton
            edge="start"
            onClick={onBackClick}
            className={classes.noHighlight} // Disable hover effect
            disableRipple
          >
            <ArrowBackIosIcon className={classes.blackIcon} />
            <Typography className={classes.backText}>Back</Typography>
          </IconButton>
        </div>
        <Typography variant="h6" className={classes.titleText}>
          {title}
        </Typography>
        {rightContent && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
            {rightContent}
          </div>
        )}
      </DialogTitle>
      <Divider />
    </>
  );
};

export default CustomDialogTitle;
